import { useState } from "react"
import { Modal, Button } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import QRGenerator from "../generateQrCode"
import Slider from "@mui/material/Slider"

interface QRSizeModalProps {
  show: boolean
  onHide: () => void
  qrValue: string
  qrSize: number
  selectedColor: string
  setQrSize: (value: number) => void
  // onSizeChange: (size: any) => void
  setQrPosition: (value: any) => void
  onConfirm: () => void
  qrPosition: { x: number; y: number }
  uploadedImageRef: React.RefObject<HTMLImageElement>
  qrDivRef: React.RefObject<HTMLDivElement>
}

export const QRSizeModal = ({
  show,
  onHide,
  qrValue,
  qrSize,
  setQrSize,
  selectedColor,
  // onSizeChange,
  setQrPosition,
  onConfirm,
  qrPosition,
  uploadedImageRef,
  qrDivRef,
}: QRSizeModalProps) => {
  const { t } = useTranslation()
  const handleSliderChange = (_event: Event, newValue: number | number[]) => {
    if (typeof newValue === "number") {
      const newSize = newValue * 1 // Adjust the multiplier if needed
      setQrSize(newSize)

      if (uploadedImageRef?.current && qrDivRef?.current) {
        const parentRect = uploadedImageRef.current.getBoundingClientRect()
        const qrRect = qrDivRef.current.getBoundingClientRect()

        // Revalidate position to ensure the QR code is within bounds
        const newX = Math.min(
          Math.max(qrPosition.x, 1),
          parentRect.width - newSize - 14,
        )
        const newY = Math.min(
          Math.max(qrPosition.y, 1),
          parentRect.height - newSize - 14,
        )

        // Update position after resizing
        setQrPosition({ x: newX, y: newY })
      }
    }
  }
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Body className="p-5 d-flex flex-column justify-content-center align-items-center gap-2">
        <div
          style={{
            width: "300px",
            height: "250px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignContent: "center",
          }}
        >
          <h5 className="mb-1 mt-1 text-center">
            {t("invitation.changeQrCodeSize")}
          </h5>

          <div className="d-flex flex-column">
            <div
              style={{
                height: "auto",
                width: "auto",
              }}
              onClick={() => onHide()}
            >
              <QRGenerator
                value={qrValue}
                bgColor={selectedColor}
                size={qrSize}
                // color={selectedColor}
              />
            </div>
          </div>

          <Slider
            defaultValue={50}
            min={40}
            max={130}
            step={1}
            value={qrSize}
            // onChange={(event, value) => onSizeChange(value)}
            onChange={handleSliderChange}
            aria-label="Default"
            valueLabelDisplay="auto"
          />

          <Button className="mt-3 mb-2" onClick={onConfirm}>
            {t("buttons.update")}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  )
}
